import { resolvePreScaleStrategy } from './preScaleStrategies';
import { IMAGE_PROCESSING_ERRORS } from './validateImageSize';

const normalizeImage = async (file) => {
  const preScale = resolvePreScaleStrategy();

  if (!preScale) {
    throw new Error(IMAGE_PROCESSING_ERRORS.UNSUPPORTED_ERROR);
  }

  const outputName = file.name.replace(/\.\w+$/, '.jpg');
  return preScale(file, outputName);
};

export default normalizeImage;
